<template>
    <div class="mt-8 border-t pt-8">
        <div
            class="mb-3 flex w-full items-center justify-between text-2xl font-semibold tracking-wider"
        >
            <slot name="title" />
        </div>

        <slot />
    </div>
</template>
